import PropTypes from 'prop-types';
import { BsCheckLg } from 'react-icons/bs';

const AddonBenefitList = ({ benefits, className = '' }) => (
	<ul className={`space-y-1.5 text-left ${className}`}>
		{benefits.map((benefit) => (
			<li key={benefit} className="flex items-start gap-2 text-sm text-text">
				<BsCheckLg className="mt-0.5 h-4 w-4 shrink-0 text-success-700" />
				<span>{benefit}</span>
			</li>
		))}
	</ul>
);

AddonBenefitList.propTypes = {
	benefits: PropTypes.arrayOf(PropTypes.string).isRequired,
	className: PropTypes.string,
};

export default AddonBenefitList;
